













import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { getModule } from "vuex-module-decorators";

import FormErrors from "@/lib/components/FormErrors.vue";
import SubmitButton from "@/lib/components/SubmitButton.vue";

import GeneralFormMixin from "@/lib/mixins/GeneralForm";
import dataStore from "@/store";

import CustomerPreviewStore from "../store";

@Component({
  components: {
    FormErrors,
    SubmitButton,
  },
})
export default class AcceptationForm extends mixins(GeneralFormMixin) {
  @Prop({ required: true })
  public readonly plushieId!: string;

  private fCustomerPreviewDataStore: CustomerPreviewStore;

  constructor() {
    super();
    this.fCustomerPreviewDataStore = getModule(CustomerPreviewStore, dataStore);
  }

  protected async performSubmit(): Promise<void> {
    await this.fCustomerPreviewDataStore.createCustomerPreviewApprovement(
      this.plushieId
    );

    await this.$router.push({
      name: "AcceptSuccessPage",
      query: { plushieId: this.plushieId },
    });
  }
}
